import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import styles from "./ReportCard.module.scss";
import { Layout, PageHeader, UnvButton, Card, EmptyState, Icon } from "components";
import FrontPhoto from "./components/front-photo/FrontPhoto";
import ScanDataContext from "./components/ScanDataContext";
import { postTabel, getTabel, getTabelLast, getQrInfo } from "service/TabelService";
import Notification from "utils/Notifications";
import moment from "moment";
import CalendarPage from 'pages/CalendarPage/CalendarPage'
import QRCode from 'qrcode.react';
import QRCodeLib from 'qrcode';
import { useLocation, useNavigate } from "react-router-dom";
import play from  "assets/icons/play.png"
import stopbutton from  "assets/icons/stopbutton.png"

const ReportCard = () => {
  const { t } = useTranslation('common');
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [cameraEnabled, setCameraEnabled] = useState(false);
  const [scanData, setScanData] = useState(null);
  const toggleCamera = () => {
    setCameraEnabled(!cameraEnabled);
  };

  const handleSubmit = async (scanData) => {
    try {
      if (scanData?.room) {
        const formData = new FormData();
        const auditorium =
          `${scanData.campus}` +
          "/" +
          `${scanData.corpus}` +
          "/" +
          `${scanData.room}`;
        formData.append("id_organizations", scanData.campus);
        formData.append("auditorium", auditorium);
        const geoloc_info =
          `${scanData.latitude}` + ", " + `${scanData.longitude}`;
        formData.append("geo", geoloc_info);
        formData.append("image", scanData.photo);
        let response = await postTabel(formData);

        setNotify({
          isOpen: true,
          message: "Успешно отмечены",
          type: "success",
          sound: "success",
        });
        // Wave Final (P1-F14): без reload — пользователь вернётся в feed
        // через onClose-логику родителя; данные подтянутся свежим запросом.
      }
    } catch (error) {
      alert(error);
      setNotify({
        isOpen: true,
        message: "Ошибка",
        type: "error",
      });
    }
  };
  const [datas, setDatas] = useState([]);
  const [datal, setDatal] = useState([]);
  const [dataqr, setDataQR] = useState([]);
  const items = dataqr.qr_selections;
  const navigate = useNavigate();

  const qrCodeRef = useRef(null);
  const fileName = items  || 'default';
  const [isQRCodeGenerated, setIsQRCodeGenerated] = useState(false);
  const generateQRCode = () => {
    setIsQRCodeGenerated(true);
  };
  const downloadQRCode = () => {
    const canvas = document.createElement('canvas');
    QRCodeLib.toCanvas(canvas, items,   {
      color: {
        dark: '#000000',    
        light: '#f5deb300',  
      },
      width: 300, 
      height: 300,
    },(error) => {
      
      if (error) {
      } else {
        const qrCodeUrl = canvas.toDataURL('image/png');
        const link = document.createElement('a');
        link.href = qrCodeUrl;
        link.download = `${fileName || 'qrcode'}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };
  const getData = async () => {
    try {
      let response = await getTabel(datas);
      setDatas(response.data);
    } catch (error) {}
    try {
    
      let response1 = await getTabelLast(datal);
      setDatal(response1.data);
     
    } catch (error) {}
    try {
    
      let responseqr = await getQrInfo(dataqr);
      setDataQR(responseqr.data);
    } catch (error) {}
    
  };
  useEffect(() => {
    getData();
    if (scanData?.room) {
      handleSubmit(scanData);
    }
  }, [scanData]);

  const formatDate = (dateString) => {
    const date = moment(dateString, "DD.MM.YYYY HH:mm");
    return date.format("HH:mm");
  };
  const formatDateInfo = (dateString) => {
    const date = moment(dateString, "DD.MM.YYYY");
    const today = moment();
  
    if (date.isSame(today, 'day')) {
      return date.format('Сегодня');
     }
    
    else if(date.isSame(today, 'year')){
      return date.format('DD MMMM')
     } 
     else if (date.isBefore(today, 'day')) {
      return date.format('DD MMMM YYYY');
    }
    else {
      return date.format('DD MMMM YYYY');
    }
  };


  return (
    <Layout>
      <PageHeader
        icon={<Icon name="clock" size={28} />}
        title={t('auto.reportcard.title', 'Табель учёта')}
        subtitle={t('auto.reportcard.subtitle', 'Отметка прихода/ухода и история')}
      />
      <div>
        <div className="qr-container">
        <div className={styles.wrapper} style={{marginBottom:'20px'}}>
          {dataqr?.qr_selections != null ? <><div className="qr-message">{t('report_card.qr_company')} </div>
        <button className={styles.btn3} onClick={downloadQRCode}>
          <QRCode value={items} style={{width:"50px", height:"50px"}} ref={qrCodeRef} />
        </button> </> :
        <>
        <div className="qr-message">{t('report_card.qr_unavailable')}  </div>

        <UnvButton variant="primary" iconLeft="building" onClick={() => navigate(`/structure/`)}>
          {t('auto.reportcard.fill_company_data', 'Заполнить данные о компании')}
        </UnvButton> </>
        }

        </div>
          <div className={styles.wrapper}>
       
          <div className="qr-message">{t('report_card.history_title')} </div>
          <ScanDataContext.Provider value={{ scanData, setScanData }}>
            <div className="combined-app">
              {!cameraEnabled ? (
                <>
                
                  {datal.status_info != "Начат" && datal.status_info != "Завершен"  ?
                  <>
                 
                 <button onClick={toggleCamera} className={styles.btn_tabel}> Пройти отметку  <img className={styles.image_icon} src={play} alt="" /></button>  
                  </>
                   :  <> { datal.status_info != "Завершен" ? <button onClick={toggleCamera} className={styles.btn_tabel} > Завершить <img className={styles.image_icon} src={stopbutton} alt="" /> </button> :   <td>За сегодня {datal?.working_time}</td> } </>}
               
                </>
              ) : (
                <FrontPhoto />
              )}
            </div>
          </ScanDataContext.Provider>
          </div>
          <table className={styles.table_info}>
            <thead>
              <tr >
                <th>{t('common.date')}</th>
                <th>{t('report_card.th_started')}</th>
                <th>{t('report_card.th_start_loc')}</th>
                <th>{t('report_card.th_finished')}</th>
                <th>{t('report_card.th_end_loc')}</th>
                <th>{t('report_card.th_hours')}</th>
                <th>{t('common.status')}</th>
                <th>{t('report_card.th_total')}</th>
              </tr>
            </thead>
            <tbody >
              {[...datas].map((item) => {
                 return (
                <tr >
                  <td> {!item?.date_day ? " " : formatDateInfo(item?.date_day) } </td>
                
                  <td>{formatDate(item?.time)}</td>
                  <td>{item?.auditorium}</td>
                  <td> {!item?.time_end ? " " : formatDate(item?.time_end) }  </td>
                  <td>{item?.auditorium_end}</td>
                  <td>{item?.working_time}</td>
                  <td>{item?.status_info}</td>
                  <td>{!item?.all_time_in_work ? "" : <> {item?.all_time_in_work}</>} </td>
                </tr>
                 )
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{marginTop:"20px"}}>
      <CalendarPage/>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </Layout>
  );
};

export default ReportCard;
